<div [hidden]="hide" class="table-responsive dhl-table-autoscroll-v2" [ngClass]="{'horizontalScrollEnable': configData.horizontalScrollEnable && !(isHandset$ | async)}" #scroll (scroll)="onScroll($event)">
  <span>{{configData.title}}</span>
  <span *ngIf ="tableconfig.rowOptions?.isSelectAllCount" class="vehicles"><span id="poSelectCount">{{selectionArray.length }}</span>{{tableconfig.rowOptions?.isSelectAllCount}}</span>
  <table class="table table-hover dhl-tablelayout-v2 dhl-table-layout-fixed-v2" *ngIf="(isHandset$ | async) === false">
    <thead>
      <tr id="TableListHeadRow">
        <th class="align-middle dhl-table-align-hover-v2" id="TableListHead" *ngFor="let tableHeaders of tHeaders ; trackBy: let i = index"
          [style.max-width.px]="tableHeaders.width" [style.right]="tableHeaders.right" [style.position]="tableHeaders.position" [style.left]="tableHeaders.left" [style.z-index]="tableHeaders.zIndex"
          [ngClass]="{'dhl-table-highlight-columns-v2':tableHeaders.highlightInTabletView,'dhl-table-highlight-v2':tableHeaders.highlight, 'dhl-settings-v2':tableHeaders.primaryText.key==='Settings'}">
          <div *ngIf="ifColumnVisible(tableHeaders)">
          <span class="grip-class"></span>
          <span *ngIf="tableHeaders.primaryText.key ==='Settings'">
            <img src="{{tableHeaders.image}}" (click)="displayColumnOrder($event,'')" class="cursor">
          </span>
          <span
            *ngIf="tableconfig.rowOptions?.mutipleRowOperation && tableHeaders.primaryText.value == 'select' && tableconfig.rowOptions?.isSelectAll"
            (click)="setCheckAll(tableconfig.rowOptions.events, $event)">
            <div class="option">
              <div class="img">
                <span class="checkbox empty headerCheckBox"
                  [ngClass]="{'checked': checkboxAllStatus,'disabled': !checkboxAllStatus}"></span>
                <!-- checkboxAllStatus ? 'checked' : 'empty' -->
              </div>
            </div>
          </span>
          <span (click)="onPageSorting(tableHeaders,i,tableconfig.rowActions, $event)">
          <span *ngIf="tableHeaders.sortDefault && tableHeaders.sortable" class="dhl-sorting-v2" ></span>
          <span *ngIf="tableHeaders.visible && tableHeaders.sortASC" class="dhl-sorting-v3" ></span>
          <span *ngIf="tableHeaders.visible && tableHeaders.sortDES" class="dhl-sorting-v4" ></span>
          <span *ngIf="tableHeaders.visible" class="dhl-head-font-v2 cursor" [ngClass]="{'addTitleFont': tableHeaders.sortDES || tableHeaders.sortASC}">{{tableHeaders.title | translate}}</span>
          <span *ngIf="tableHeaders.popup && tableHeaders.visible" class="dhl-popup-v2"
            (mouseenter)="isDisplayStatus=true||popmsgHead=tableHeaders.popupMsgHead" (mouseleave)="isDisplayStatus=false"></span>
          <!-- <app-generic-table-header-hint-v2 class="hint" *ngIf="tableHeaders.popup && tableHeaders.visible"></app-generic-table-header-hint-v2> -->
          </span>
          <span *ngIf="selfServiceConfig">
            <span class="dhl-edit-selfservice" (click)="editFieldConfig('false',tableHeaders)">
                ___
            </span>
          </span>
          <span *ngIf="tableHeaders.settingsImage" class="dhl-settings-v2-icon">
            <img src="{{tableHeaders.settingsImage}}" (click)="displayColumnOrder($event,'')" class="cursor">
          </span>
         </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rowData of tableRows;trackBy: index" [hidden]="rowData.hidden"
        [ngClass]="{'disabled':rowData.disabled || rowData.locked}"
        (click)="rowData[businessObjectIdType]!== null ||  rowData[businessObjectIdType]!== undefined?handleRowActions($event, 'ROW_CLICK', rowData[businessObjectIdType], rowData):null;configData.recentSearcheAutopopulate ? onRowClickHandler(rowData, tableconfig.rowOptions, $event):null;"
        [title]="rowData.title">
        <td *ngFor="let tableHeaders of tHeaders;trackBy: index" class="dhl-verticalAlignCenter-v2 cursor"  [style.max-width.px]="tableHeaders.width" [style.right]="tableHeaders.right" [style.left]="tableHeaders.left" [style.position]="tableHeaders.position"
          [ngClass]="{'dhl-table-highlight-columns-v2':tableHeaders.highlightInTabletView,'dhl-table-highlight-v2':tableHeaders.highlight, 'dhl-settings-v2':tableHeaders.primaryText.key==='Settings', 'remove-padding':tableHeaders.columnClickable}"
          >
          <div *ngIf="ifColumnVisible(tableHeaders)">
          <div *ngIf="tableHeaders.columnClickable; else removeTDClick" class="column-action"
          (click)="handleColumnActions($event, rowData, tableHeaders)">
            <span  *ngFor="let Textkey of tableHeaders.primaryText.value; trackBy: let i = index">
              <span *ngIf="tableconfig.rowOptions?.mutipleRowOperation && Textkey === 'select'"
                (click)="selectedOption(rowData,$event, tableconfig.rowOptions.events)" [ngClass] = "{'checkbox_disabled':checkdisableRow(tableHeaders.CheckSelection,rowData['status'],$safeNavigationMigration(tableconfig.rowOptions?.events[0]?.eventConfig?.matchcolumnValue))}">
                <div class="option">
                  <div class="img">
                    <span class="checkbox empty"
                      [ngClass]="{'checked': rowData.selected,'empty': !rowData.selected, 'disabled': rowData.disabled}"></span>
                    <!--  [ngClass]="rowData.selected ? 'checked' : 'empty'" -->
                  </div>
                </div>
              </span>
              <span *ngIf="tableHeaders.columnType !== 'text'; else elseBlock" class="">
                <span *ngIf="Textkey === 'status' && tableHeaders.colType !== 'image'; else elseBlock1">
                  <div style="display: flex;">
                    <!-- <div [ngClass]="{'dhl-row-actions': true, 'dhl-vip-flag': rowData.orderExpedite}"></div> -->
                    <div title="{{ configData['popupSpace'] && rowData['statusWithSpace'] ? rowData['statusWithSpace'] : rowData['status'] }}">
                      <span class="dhl-type {{rowData['className']}}">{{rowData["TypeText"]}}</span>
                    </div>
                    <div style="display: flex; flex-direction: column;">
                      <div [ngClass]="{'dhl-row-actions': true, 'tool dhl-vip-flag-v2': rowData.orderExpedite}">
                        <span class="tooltext" *ngIf="rowData.orderExpedite === true">VIP</span>
                      </div>
                      <div
                        [ngClass]="{'dhl-row-actions': true, 'tool dhl-escalation-flag-v2': rowData.escalationFlag, 'setMargin': rowData.orderExpedite === false}">
                        <span class="tooltext" *ngIf="rowData.escalationFlag === true">Escalated</span>
                      </div>
                      <div *ngIf="configData['reverificationFlag']===true && rowData.orderReverification === true" [ngClass]="{'dhl-row-actions': true, 'tool dhl-reverification-flag-v2': true,'setMargin': rowData.escalationFlag === false,'setMargin2':rowData.orderExpedite === true && rowData.escalationFlag === true}">
                        <span class="tooltext" *ngIf="rowData.orderReverification === true">Reverification</span>
                      </div>
                    </div>
                  </div>
                </span>

                <ng-template #elseBlock1>
                  <span
                    *ngIf="Textkey === 'STATUS_VALUE_XID'||Textkey === 'ORDER_TYPE_XID'||Textkey === 'OB_LINE_STATUS_VALUE_XID' || Textkey === 'status' || Textkey === 'ORL_STATUS' || Textkey === 'STATUS'; else elseBlock">
                    <div style="display: flex;">
                      <!-- <div [ngClass]="{'dhl-row-actions': true, 'dhl-vip-flag': rowData.orderExpedite}"></div> -->
                      <div>
                        <span [title]="rowData[Textkey] === 'MRN_NUMBER_RECEIVED_YES' ? 'MRN_ENTERED' : (rowData[Textkey] === 'MRN_NUMBER_RECEIVED_NO' ? 'MRN_NOT_ENTERED' : rowData[Textkey])" class="dhl-type"
                          [ngClass]="'dhl-' + (rowData[Textkey]?.toLowerCase().split(' ').join('')) + '-status-v2'"></span>
                      </div>
                    </div>
                  </span>
                </ng-template>
                <!-- here we can write dynamic code to render icon -->
              </span>
              <ng-template #elseBlock>
                <div *ngIf = "tableHeaders.primaryText.type === 'image';else textFont">
                  <div>
                    <span [ngClass] = "{'dhl-success-icon-v2':rowData[Textkey]===true, 'dhl-cancel-icon-v2':rowData[Textkey]===false}"></span>
                    <!-- <span>{{rowData[Textkey+"Text"]}}</span> -->
                  </div>
                </div>
              <ng-template #textFont>
                <div *ngIf="tableHeaders.primaryText.value.length === 1;else elseFont">
                  <div class="dhl-font1-v2" [ngClass]="{'dhl-font-wrap': tableHeaders.toolTip }" [title]="tableHeaders.toolTip ?rowData[Textkey]:''">
                    {{rowData[Textkey]}}
                  </div>
                </div>
                <ng-template #elseFont>
                  <div *ngIf="i===0 && rowData[Textkey]" class="dhl-font2-v2">
                    {{rowData[Textkey]}}
                  </div>
                  <div *ngIf="i===1 && rowData[Textkey]" class="dhl-font1-v2" >
                    {{rowData[Textkey]}}
                  </div>
                  <div *ngIf="i===2 && rowData[Textkey]" class="dhl-font2-v2">
                    {{rowData[Textkey]}}
                  </div>
                </ng-template>
              </ng-template>
              </ng-template>


              <span *ngIf="Textkey==='actions'" class = "dhl-actions-v2">
                <!-- <table class="table-borderless" width="100%">
                  <tr> -->
                    <span class="dhl-hand-pointer-v2 dhl-action-styling-v2" *ngFor="let action of rowActions;trackBy: index" [hidden]="action.hidden" [ngClass]="{'tool': action.toolTip, 'dhl-row-actions': true, 
                    'dhl-view-v2': (action.name === 'edit' || action.name === 'draftView'),
                    'dhl-cancel-v2': (action.name === 'cancel' || action.name === 'decline'),
                    'dhl-copy-v2': action.name === 'copy',
                    'dhl-download-v2': action.name === 'download',
                    'dhl-search-v2': action.name === 'search',
                    'dhl-delete-v2': action.name === 'delete',
                    'dhl-pod-download-v2': action.name ==='pod-download',
                    'dhl-upload-v2': (action.name === 'upload' || action.name === 'approve'),
                    'dhl-release-v2': action.name === 'release',
                    'dhl-resend-v2': isResend(rowData,action),
                    'dhl-mark-vip-v2': isVip(rowData,action), 'dhl-unmark-vip-v2': isNotVip(rowData,action),
                    'dhl-default-escalation-v2': isNotEscalated(action,rowData),
                    'dhl-default-escalationNotesHistory-v2': isEscalationNotesHistory(action,rowData),
                    'dhl-default-holdDetails-v2': holdDetails(action,rowData),
                    'dhl-default-orderNotes-v2': isOrderNotes(action,rowData),
                    'dhl-filled-escalation-v2': isEscalated(action,rowData),
                    'disabled': action.disabled || (isCancelled(rowData.status, action) || isDisable(action,rowData) || accessActionsByStatus(action,rowData) || checkAccess(action))
                    }" (click)="!accessActionsByStatus(action,rowData) && handleRowActions($event, action, rowData[businessObjectIdType], rowData)">
                    <span class ="tooltext">{{action.toolTip}}</span>
                  </span>
                  <!-- hard code -->
                    <!-- <td *ngIf="rowActions[0].name === 'verify'">
                      <input type="checkbox" class="dhl-checkbox-v2"
                        (click)="handleRowCheck($event, rowActions[0], rowData[businessObjectIdType], rowData)">
                    </td> -->
                  <!-- hard code -->
                  <!-- </tr>
                </table> -->
              </span>
            </span>
          </div>
          <ng-template #removeTDClick>
            <span *ngFor="let Textkey of tableHeaders.primaryText.value;trackBy: let i = index">
              <span *ngIf="tableconfig.rowOptions?.mutipleRowOperation && Textkey === 'select'"
                (click)="selectedOption(rowData,$event, tableconfig.rowOptions.events)" [ngClass] = "{'checkbox_disabled':checkdisableRow(tableHeaders.CheckSelection,rowData['status'],$safeNavigationMigration(tableconfig.rowOptions?.events[0]?.eventConfig?.matchcolumnValue))}">
                <div class="option">
                  <div class="img">
                    <span class="checkbox empty"
                      [ngClass]="{'checked': rowData.selected,'empty': !rowData.selected, 'disabled': rowData.disabled}"></span>
                    <!--  [ngClass]="rowData.selected ? 'checked' : 'empty'" -->
                  </div>
                </div>
              </span>
              <span *ngIf="tableHeaders.columnType !== 'text'; else elseBlock" class="">
                <span *ngIf="Textkey === 'status' && tableHeaders.colType !=='image'; else elseBlock1">
                  <div style="display: flex;">
                    <!-- <div [ngClass]="{'dhl-row-actions': true, 'dhl-vip-flag': rowData.orderExpedite}"></div> -->
                    <div title="{{ configData['popupSpace'] && rowData['statusWithSpace'] ? rowData['statusWithSpace'] : rowData['status'] }}">
                      <span class="dhl-type {{rowData['className']}}">{{rowData["TypeText"]}}</span>
          					</div>
                    <div style="display: flex; flex-direction: column;">
                      <div *ngIf="rowData.escalationFlag===true" class=" dhl-row-actions tool dhl-escalation-flag-v2">
                        <span class="tooltext" >Escalated</span>
                      </div>
                      <div *ngIf="configData['reverificationFlag']===true && rowData.orderReverification===true" class="dhl-row-actions tool dhl-reverification-flag-v2">
                          <span class="tooltext">Reverification</span>
                      </div>
                      <div *ngIf="rowData.orderExpedite === true" class="dhl-row-actions tool dhl-vip-flag-v2">
                        <span class="tooltext">VIP</span>
                      </div>
                      <div *ngIf="rowData.isContracted === true  || rowData.isContracted === 'Y'" class="dhl-row-actions tool dhl-CCL-flag-v2">
                        <span class="tooltext">CCL</span>
                      </div>
                      <div *ngIf="rowData.isL2L === true || rowData.isL2L === 'Y'" class="dhl-row-actions tool dhl-L2L-flag-v2">
                        <span class="tooltext">L2L</span>
                      </div>
                      <div *ngIf="rowData.isL2R === true  || rowData.isL2R === 'Y'" class="dhl-row-actions tool dhl-L2R-flag-v2">
                        <span class="tooltext">L2R</span>
                      </div>
                      <div *ngIf="rowData.isClientL2L === true || rowData.isClientL2L === 'Y'" class="dhl-row-actions tool dhl-CL2L-flag-v2">
                        <span class="tooltext">CL2L</span>
                      </div>  
                    </div>
                  </div>
                  <div (click)="$event.preventDefault();$event.stopPropagation()">
                    <div style="display: block;">
                      <div *ngIf="getUIStatus(rowData) === 'Info'"  [ngClass]="{'dhl-row-actions': true, 'tool': getUIStatus(rowData), 'setMargin': rowData.orderExpedite === false}">
                        <div class="action-message">
                          <app-additional-information-v2 [actionRequired]="false" [messageInfo]="configData.groupLevelAction" [configData] = "rowData.orderId" [Data] = "rowData"></app-additional-information-v2>
                        </div>
                      </div>
                      <div *ngIf="getUIStatus(rowData) === 'Action'" [ngClass]="{'dhl-row-actions': true, 'tool': getUIStatus(rowData), 'setMargin': rowData.orderExpedite === false}">
                        <div>
                          <app-additional-information-v2 [actionRequired]="true" [messageInfo]="configData.groupLevelAction" [configData] = "rowData.orderId" [Data] = "rowData"></app-additional-information-v2>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>

                <ng-template #elseBlock1>
                  <span
                    *ngIf="Textkey === 'STATUS_VALUE_XID'|| Textkey === 'ORDER_TYPE_XID'||Textkey === 'OB_LINE_STATUS_VALUE_XID' || Textkey === 'status' || Textkey === 'ORL_STATUS' || Textkey === 'STATUS'; else elseBlock">
                    <div style="display: flex;">
                      <!-- <div [ngClass]="{'dhl-row-actions': true, 'dhl-vip-flag': rowData.orderExpedite}"></div> -->
                      <div *ngIf="Textkey !== 'otm_Statusvalues'">
                       <span [title]="rowData[Textkey] === 'MRN_NUMBER_RECEIVED_YES' ? 'MRN_ENTERED' : (rowData[Textkey] === 'MRN_NUMBER_RECEIVED_NO' ? 'MRN_NOT_ENTERED' : rowData[Textkey])" class="dhl-type"
                          [ngClass]="'dhl-' + (rowData[Textkey]?.toLowerCase().split(' ').join('')) + '-status-v2'"></span>
                       </div>
                    </div>
                  </span>
                </ng-template>
                <!-- here we can write dynamic code to render icon -->
              </span>
              <ng-template #elseBlock>
                <div *ngIf = "tableHeaders.primaryText.type === 'image'|| tableHeaders.primaryText.type ===  'imageText';else textFont">
                  <div>
                    <span  [ngClass] = "{'dhl-success-icon-v2':rowData[Textkey]===true, 'dhl-cancel-icon-v2':rowData[Textkey]===false}"></span>
                    <span *ngIf ="tableHeaders.primaryText.type ===  'imageText'" [ngClass]="{'imageTextGreen':rowData[Textkey]===true, 'imageTextRed':rowData[Textkey]==false}" >{{rowData[Textkey+"Text"]}}</span>
                  </div>
                </div>
              <ng-template #textFont>
                <div *ngIf="tableHeaders.primaryText.type === 'object';else elseLegacyBlock">
                  <div [ngClass]="Textkey.className" *ngIf="!tableHeaders.isconvertUom">
                    <span> {{rowData[Textkey.key]}} </span>                 
                  </div>
                  <div  *ngIf="tableHeaders?.isconvertUom" [ngClass]="Textkey.className" >
                  <span> 
                    {{rowData[Textkey.key]}} 
                  </span>
                  </div>
                </div>
                <ng-template #elseLegacyBlock>
                  <div *ngIf="tableHeaders.primaryText.value.length === 1;else elseFont;">
                    <ng-container *ngIf="tableHeaders.type === 'star'; else elseText">
                      <div class="material-icons material-icon-color" color="primary"
                        (click)="toggleSearchPreference($event, rowData, $safeNavigationMigration(configData?.searchResults[0]?.rowOptions))">
                        {{ isRowSelected(rowData) ? 'star' : 'star_outline' }}
                      </div>
                    </ng-container>
                    <ng-template #elseText>
                      <div *ngIf="tableHeaders?.updateData || tableHeaders?.isIcon; else plainText">
                        <div *ngFor="let data of rowData[Textkey];trackBy: index">
                          <div class="{{data}}" *ngIf=tableHeaders?.isIcon></div>
                          <div class="text-center" *ngIf="tableHeaders?.updateData">
                            {{tableHeaders?.updateData[data]}}
                          </div>
                        </div>
                      </div>
                      <ng-template #plainText>
                        <div *ngIf ="tableHeaders['ellipesActive']===true" class="dhl-font1-v2 dhl-font-ellips-enable" isEllipsisActive>
                             {{tableHeaders?.textCaps ? rowData[Textkey]?.toUpperCase() : rowData[Textkey]}}
                           </div>
                        <div class="dhl-font1-v2" *ngIf ="Textkey !== 'otm_status' && !tableHeaders['ellipesActive']" [ngClass]="getColorClass(tableHeaders,rowData)">
                          {{getFormattedData(tableHeaders, rowData, Textkey)}}
                            <!-- Cp-4386 - start -->
                            <span  class= "missingValues" 
                              *ngIf = "tableHeaders['valueMissing'] && !rowData[Textkey]">
                                Missing
                            </span>
                          <!-- Cp-4386 - end -->
                        </div>
                      </ng-template>
                    </ng-template>
                  </div>
                </ng-template>
                <ng-template #elseFont>
                  <div *ngIf="(i===0 || i===1) && rowData[Textkey] && tableHeaders['ellipesActive']===true"
                  [ngClass]="{'dhl-font2-v2' : i===0 , 'dhl-font1-v2': i===1}" class="dhl-font-ellips-enable" isEllipsisActive>
                    {{rowData[Textkey]}}
                   </div>
                  <div *ngIf="i===0 && rowData[Textkey] && !tableHeaders['ellipesActive']" class="dhl-font2-v2">{{getFormattedData(tableHeaders, rowData, Textkey)}}<span *ngIf="tableHeaders?.copyable === 'currentDiv'" class="dhl-copy-icon" (click)="copyContent($event, tableHeaders)"></span>
                  </div>
                  <div *ngIf="i===1 && !tableHeaders['ellipesActive']" class="dhl-font1-v2" [ngClass]="getFormattedClass(rowData, Textkey)">
                   <span  [ngClass] = "{'dhl-success-icon-v2':rowData[Textkey]===true, 'dhl-cancel-icon-v2':rowData[Textkey]===false}"></span>
                   <span *ngIf="getFormattedClass(rowData, Textkey) === 'imageTextRed'" class="dhl-cancel-icon-v2"></span>
                    {{getFormattedData(tableHeaders, rowData, Textkey)}}
                  </div>
                  <div *ngIf="i===2 && (rowData[Textkey] || getFormattedClass(rowData, Textkey) === 'imageTextRed')" class="dhl-font2-v2"[ngClass]="getFormattedClass(rowData, Textkey)">
                    <span *ngIf="getFormattedClass(rowData, Textkey) === 'imageTextRed'" class="dhl-cancel-icon-v2">
                    </span>
                    {{getFormattedData(tableHeaders, rowData, Textkey)}}
                    <span *ngIf="tableHeaders?.copyable === 'All' && rowData[Textkey]" class="dhl-copy-icon" (click)="copyContent($event, tableHeaders)">
                    </span>
                  </div>
                  <div *ngIf="i===3 && rowData[Textkey] && !tableHeaders['ellipesActive']" class="dhl-font1-v2"  [ngClass]="getFormattedClass(rowData, Textkey)">
                    <span [ngClass] = "{'dhl-diamond-icon-v2':rowData[Textkey]===true}"></span>
                    {{getFormattedData(tableHeaders, rowData, Textkey)}}
                  </div>
                   <div *ngIf="i===4 && rowData[Textkey]" class="dhl-font2-v2">
                    {{rowData[Textkey]}}
                   </div>
                </ng-template>
              </ng-template>
              </ng-template>

              <span *ngIf="tableHeaders.dataBinding === 'icon'">
                <span *ngFor="let icon of tableHeaders.iconDetails;trackBy: index">
                  <span *ngIf="rowData[icon.value]">
                  <img src="{{icon.iconUrl}}" class="dhl-tags-col-{{icon.value}}" title="{{icon.toolText}}">
                </span>
                </span>
              </span>
              <span *ngIf="Textkey === 'otm_status'">
                <div style="float: left;" *ngFor="let otmsttaus of rowData['otm_Statusvalues']">
                  <div class="dhl-type-otm-status padding-otm-status {{otmsttaus.className}}">{{otmsttaus.status_Text}}</div>
                </div>
              </span>
              <span *ngIf="Textkey==='actions'" class = "dhl-actions-v2">
                <!-- <table class="table-borderless" width="100%">
                  <tr> -->
                    <span *ngFor="let action of rowActions;trackBy: index">
                    <span class="dhl-hand-pointer-v2 dhl-action-styling-v2" *ngIf="shouldDisplayAction(action, rowData)" [hidden]="action.hidden" [ngClass]="{'tool': action.toolTip, 'dhl-row-actions': true, 'dhl-view-v2': (!rowData.shipStatus && (action.name === 'edit' || action.name === 'draftView')),
                    'dhl-truckview-v2': (rowData.shipStatus && (action.name === 'edit' || action.name === 'draftView')),
                    'dhl-cancel-v2': (action.name === 'cancel' || action.name === 'decline'),
                    'dhl-copy-v2': action.name === 'copy',
                    'dhl-download-v2': action.name === 'download',
                    'dhl-search-v2': action.name === 'search',
                    'dhl-delete-v2': action.name === 'delete',
                    'dhl-resend-v2': isResend(rowData,action),
                    'dhl-pod-download-v2': action.name === 'pod-download',
                    'dhl-upload-v2': (action.name === 'upload' || action.name === 'approve'),
                    'dhl-release-v2': action.name === 'release',
                    'dhl-mark-vip-v2': isVip(rowData,action), 'dhl-unmark-vip-v2': isNotVip(rowData,action),
                    'dhl-default-escalation-v2': isNotEscalated(action,rowData),
                    'dhl-default-escalationNotesHistory-v2': isEscalationNotesHistory(action,rowData),
                    'dhl-default-holdDetails-v2': holdDetails(action,rowData),
                    'dhl-default-orderNotes-v2': isOrderNotes(action,rowData),
                    'dhl-filled-escalation-v2': isEscalated(action,rowData),
                    'disabled': action.disabled || (isCancelled(rowData.status, action) || isDisable(action,rowData) || accessActionsByStatus(action,rowData) || checkAccess(action))
                    }" (click)="!accessActionsByStatus(action,rowData) && handleRowActions($event, action, rowData[businessObjectIdType], rowData)">
                    <!-- <span class ="tooltext">{{action.toolTip | translate}}</span> -->
                    <span [ngClass]=" action.name === 'download' ? 'tooltext-width' : 'tooltext'">{{action.toolTip | translate}}</span>
                  </span>
                </span>
                  <!-- hard code -->
                    <!-- <td *ngIf="rowActions[0].name === 'verify'">
                      <input type="checkbox" class="dhl-checkbox-v2"
                        (click)="handleRowCheck($event, rowActions[0], rowData[businessObjectIdType], rowData)">
                    </td> -->
                  <!-- hard code -->
                  <!-- </tr>
                </table> -->
              </span>
            </span>
          </ng-template>
          
          </div>
        </td>
      </tr>
    </tbody>


      <tfoot *ngIf="isLoading || showLoadMoreLabel">
        <tr>
          <td [attr.colspan]="tHeaders.length">
            <div [hidden]="!isLoading">
              <div  class="spinner-load-more-aligment">
              <div class="custom-spinner progress-spinner-load-more"  mode="determinate"  value="100"></div>
              </div>
              </div>
            <div [hidden]="!showLoadMoreLabel" class="dhl-table-pagination-label cursor"  (click)="loadMore(tableconfig.rowActions, $event)">{{enum.Load_More_Button | translate}}</div>
          </td>
        </tr>
      </tfoot>


  </table>
  <table class="table dhl-tablelayout-v2" id="SmallDevice" *ngIf="(isHandset$ | async)">
    <thead>
      <tr class="dhl-header-row">
        <th class="align-middle dhl-table-align-hover-v2 dhl-col-align"
          *ngFor="let tableHeaders of tHeaders | slice:startIndex:endIndex;trackBy:let i = index">
          <span *ngIf="tableHeaders.visible" class="dhl-head-font-v2">{{tableHeaders.title | translate}}</span>
          <span *ngIf="tableHeaders.popup && tableHeaders.visible" class="dhl-popup-v2"
            (click)="isDisplayStatus=!isDisplayStatus||popmsgHead=tableHeaders.popupMsgHead" (mouseleave)="isDisplayStatus=false"></span>
        </th>
        <th class="align-middle dhl-manage-columns-v2" (click)="displayColumnOrder($event)"><img
            src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,120,24,24))"
            class="dhl-manage-column-img-v2 cursor"></th>
      </tr>
    </thead>
    <tbody *ngFor="let rowData of tableRows;trackBy: let i = index;" id="index" class="small-table-row">
      <tr class="dhl-record-border-v2" [hidden]="rowData.hidden" [ngClass]="{'collapse-row': rowData.isSelRow, 'selected-row':rowData.selected, 'disabled':rowData.disabled || rowData.locked}" (click)="displayOrderDetails(i,rowData)">
        <td *ngFor="let tableHeaders of tHeaders | slice:startIndex:endIndex;trackBy: index" class="dhl-header-col" [style.max-width]="tableHeaders.width">
          <span *ngFor="let Textkey of tableHeaders.primaryText.value; trackBy:let i = index">
            <span *ngIf="tableconfig.rowOptions?.mutipleRowOperation && Textkey === 'select'"
              (click)="selectedOption(rowData,$event, tableconfig.rowOptions.events);$event.stopPropagation()"
              [ngClass]="{'checkbox_disabled':checkdisableRow(tableHeaders.CheckSelection,rowData['status'],$safeNavigationMigration(tableconfig.rowOptions?.events[0]?.eventConfig?.matchcolumnValue))}">
              <div class="option">
                <div class="img">
                  <span class="checkbox empty"
                    [ngClass]="{'checked': rowData.selected,'empty': !rowData.selected, 'disabled': rowData.disabled}"></span>
                </div>
              </div>
            </span>
            <span *ngIf="tableHeaders.dataBinding === 'icon'" (click)="$event.stopPropagation()">
              <span *ngFor="let icon of tableHeaders.iconDetails;trackBy: index">
                <span *ngIf="rowData[icon.value]" class="dhl-tool-icon">
                  <img src="{{icon.iconUrl}}" class="dhl-tags-col-{{icon.value}}" title="{{icon.toolText}}">
                  <span class="icon-tooltip">{{icon.toolText}}</span>
                </span>
              </span>
            </span>
            <span *ngIf="tableHeaders.columnType !== 'text'; else elseBlock">
              <span *ngIf="Textkey === 'status' && tableHeaders.colType !=='image'; else elseBlock1">
                <!-- <span class="dhl-type dhl-type-{{rowData['TypeText']}}-v2">{{rowData["TypeText"]}}</span> -->
                <div style="display: flex;">
                  <!-- <div [ngClass]="{'dhl-row-actions': true, 'dhl-vip-flag': rowData.orderExpedite}"></div> -->
                  <div>
                    <span class="dhl-type {{rowData['className']}}">{{rowData["TypeText"]}}</span>
                </div>
                  <div style="display: flex; flex-direction: column;" (click)="$event.stopPropagation()">
                    <div [ngClass]="{'dhl-row-actions': true, 'tool dhl-vip-flag-v2': rowData.orderExpedite}">
                      <span class="tooltext" *ngIf="rowData.orderExpedite===true">VIP</span>
                    </div>
                    <div
                      [ngClass]="{'dhl-row-actions': true, 'tool dhl-escalation-flag-v2': rowData.escalationFlag, 'setMargin': rowData.orderExpedite === false}">
                      <span class="tooltext" *ngIf="rowData.escalationFlag===true">Escalated</span>
                    </div>
                    <div *ngIf="configData['reverificationFlag']===true && rowData.orderReverification==true" [ngClass]="{'dhl-row-actions': true, 'tool dhl-reverification-flag-v2': true,'setMargin': rowData.escalationFlag==false, 'setMargin2':rowData.orderExpedite === true && rowData.escalationFlag==true}">
                      <span class="tooltext" *ngIf="rowData.orderReverification===true">Reverification</span>
                    </div>
                  </div>
                </div>
              </span>
            </span>
            <ng-template #elseBlock1>
              <span
                *ngIf="Textkey === 'STATUS_VALUE_XID'||Textkey === 'ORDER_TYPE_XID'||Textkey === 'OB_LINE_STATUS_VALUE_XID' || Textkey === 'status' || Textkey === 'ORL_STATUS' || Textkey === 'STATUS'; else elseBlock">
                <div style="display: flex;">
                  <div>
                    <span [title]="rowData[Textkey] === 'MRN_NUMBER_RECEIVED_YES' ? 'MRN_ENTERED' : (rowData[Textkey] === 'MRN_NUMBER_RECEIVED_NO' ? 'MRN_NOT_ENTERED' : rowData[Textkey])" class="dhl-type"
                          [ngClass]="'dhl-' + (rowData[Textkey]?.toLowerCase().split(' ').join('')) + '-status-v2'"></span>
                      </div>
                </div>
              </span>
            </ng-template>
            <ng-template #elseBlock>
              <div *ngIf = "tableHeaders.primaryText.type === 'image';else textFont">
                <div>
                  <span [ngClass] = "{'dhl-success-icon-v2':rowData[Textkey]===true, 'dhl-cancel-icon-v2':rowData[Textkey]===false}"></span>
                  <!-- <span>{{rowData[Textkey+"Text"]}}</span> -->
                </div>
              </div>
            <ng-template #textFont>
              <span *ngIf="tableHeaders.primaryText.value.length === 1;else elseFont">
                <span class="dhl-font1-v2">
                  <span *ngIf="tableHeaders.columnClickable;else elseFontData" (click)="handleColumnActions($event, rowData, tableHeaders);$event.stopPropagation()">
                    {{rowData[Textkey]}} </span>
                </span>
              </span>
              <ng-template #elseFontData>
                <span class="dhl-font1-v2">
                  {{rowData[Textkey]}}
                </span>
              </ng-template>
              <ng-template #elseFont>
                <div *ngIf="(i===0 || i===1) && rowData[Textkey] && tableHeaders['ellipesActive']===true"
                [ngClass]="{'dhl-font2-v2' : i===0 , 'dhl-font1-v2': i===1}" class="dhl-font-ellips-enable" isEllipsisActive>
                  {{rowData[Textkey]}}
                 </div>
                <div *ngIf="i===0 && rowData[Textkey] && !tableHeaders['ellipesActive']" class="dhl-font2-v2">
                  {{rowData[Textkey]}}
                </div>
                <div *ngIf="i===1 && rowData[Textkey] && !tableHeaders['ellipesActive']" class="dhl-font1-v2">
                  {{rowData[Textkey]}}
                </div>
                <div *ngIf="i===2 && rowData[Textkey]" class="dhl-font2-v2">
                  {{rowData[Textkey]}}
                </div>
              </ng-template>
            </ng-template>
            </ng-template>
          </span>
        </td>
        <td class="align-middle text-end">
          <img *ngIf="!rowData.isSelRow"
            src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2800,24,24))'" />
          <img *ngIf="rowData.isSelRow"
            src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2840,24,24))'" />
        </td>
      </tr>
      <tr *ngIf="rowData.isSelRow" class="dhl-m-row-v2" [ngClass]="{'disabled':rowData.disabled || rowData.locked}" [hidden]="rowData.hidden">
        <td colspan="4" class="dhl-m-view-v2 dhl-header-col">
          <table class="table table-borderless table-view">
            <tr *ngFor="let tableHeaders of tHeaders;trackBy:let i = index;">
              <td *ngIf="tableHeaders.mobileDisplay !== false && tableHeaders.title !== 'ACTIONS'">
                <span class="dhl-head-font-v2">{{tableHeaders.title | translate}}</span>
                <!-- <span *ngIf="tableHeaders.popup && tableHeaders.visible" class="dhl-popup-v2"
                  (mouseenter)="isDisplayStatusM=true||popmsgHead=tableHeaders.popupMsgHead" (mouseleave)="isDisplayStatusM=false"></span> -->

                <span *ngIf="Textkey==='actions'" class = "dhl-actions-v2">
                  <!-- <table class="table-borderless" width="100%">
                    <tr> -->
                      <span class="dhl-hand-pointer-v2 dhl-action-styling-v2" *ngFor="let action of rowActions;trackBy: index" [hidden]="action.hidden" [ngClass]="{'tool': action.toolTip,'dhl-view-v2': (action.name === 'edit' || action.name === 'draftView'),
                      'dhl-cancel-v2': (action.name === 'cancel' || action.name === 'decline'),
                      'dhl-copy-v2': action.name === 'copy',
                      'dhl-download-v2': action.name === 'download',
                      'dhl-search-v2': action.name === 'search',
                      'dhl-delete-v2': action.name === 'delete',
                      'dhl-resend-v2': isResend(rowData,action),
                      'dhl-pod-download-v2': action.name === 'pod-download',
                      'dhl-upload-v2': (action.name === 'upload' || action.name === 'approve'),
                      'dhl-release-v2': action.name === 'release',
                      'dhl-mark-vip-v2': isVip(rowData,action), 'dhl-unmark-vip-v2': isNotVip(rowData,action),
                      'dhl-default-escalation-v2': isNotEscalated(action,rowData),
                      'dhl-default-escalationNotesHistory-v2': isEscalationNotesHistory(action,rowData),
                      'dhl-default-holdDetails-v2': holdDetails(action,rowData),
                      'dhl-default-orderNotes-v2': isOrderNotes(action,rowData),
                      'dhl-filled-escalation-v2': isEscalated(action,rowData),
                      'disabled': action.disabled || (isCancelled(rowData.status, action) || isDisable(action,rowData) || accessActionsByStatus(action,rowData) || checkAccess(action))
                        }" (click)="!accessActionsByStatus(action,rowData) && handleRowActions($event, action, rowData[businessObjectIdType], rowData)">
                      <span class = "tooltext">{{action.toolTip}}</span></span>
                      <!-- <td *ngIf="rowActions[0].name === 'verify'">
                        <input type="checkbox" class="dhl-checkbox-v2"
                          (click)="handleRowCheck($event, rowActions[0], rowData[businessObjectIdType], rowData)">
                      </td> -->
                    <!-- </tr>
                  </table> -->
                </span>
            </td>
            <td *ngIf="tableHeaders.mobileDisplay !== false && tableHeaders.title !== 'ACTIONS'">
                <span *ngIf="tableHeaders.dataBinding === 'icon'">
                  <span *ngFor="let icon of tableHeaders.iconDetails;trackBy: index">
                    <span *ngIf="rowData[icon.value]" class="dhl-tool-icon">
                      <img src="{{icon.iconUrl}}" class="dhl-tags-col-{{icon.value}}" title="{{icon.toolText}}">
                      <span class="icon-tooltip">{{icon.toolText}}</span>
                    </span>
                  </span>
                </span>
                <span *ngIf="tableHeaders?.primaryText?.value != 'actions' && tableHeaders.type == 'legacy';">
                  <div *ngIf="i===2" class="dhl-font1-v2">
                    {{rowData[tableHeaders.primaryText.key]}}
                  </div>
                  <div *ngIf="i===3" class="dhl-font2-v2">
                    {{rowData[tableHeaders.secondaryText.key]}}
                  </div>
                </span>
                <span *ngIf="tableHeaders?.primaryText?.value != 'actions'" #newColumn>
                  <span *ngFor="let Textkey of tableHeaders.primaryText.value;trackBy: let i = index">
                    <div *ngIf="tableHeaders.primaryText.type === 'image' || tableHeaders.primaryText.type ===  'imageText';else textFont1">
                      <div>
                        <span [ngClass]="{'dhl-success-icon-v2':rowData[Textkey]===true, 'dhl-cancel-icon-v2':rowData[Textkey]==false}"></span>
                        <span *ngIf ="tableHeaders.primaryText.type ===  'imageText'" [ngClass]="{'imageTextGreen':rowData[Textkey]===true, 'imageTextRed':rowData[Textkey]==false}">{{rowData[Textkey+"Text"]}}</span>
                      </div>
                    </div>
                    <ng-template #textFont1>
                      <span *ngIf="tableHeaders.primaryText.value.length === 1;else elseFont1">
                        <span class="dhl-font1-v2">
                          <div [ngClass]="rowData[Textkey] ? '' : 'column-action-small-v2'" *ngIf="tableHeaders.columnClickable;else elseFont2" (click)="handleColumnActions($event, rowData, tableHeaders)">
                              {{rowData[Textkey]}} </div>
                        </span>
                      </span>
                      <ng-template #elseFont2>
                        <span class="dhl-font1-v2">
                          {{rowData[Textkey]}}
                        </span>
                      </ng-template>
                      <ng-template #elseFont1>
                        <div *ngIf="i===1" class="dhl-font2-v2">
                          {{rowData[Textkey]}}
                        </div>
                        <div *ngIf="i===2" class="dhl-font1-v2">
                          {{rowData[Textkey]}}
                        </div>
                        <div *ngIf="i===3" class="dhl-font2-v2">
                          {{rowData[Textkey]}}
                        </div>
                      </ng-template>
                    </ng-template>
                  </span>
                </span>
            </td>
            <td class="dhl-action-row dhl-m-action-v2" *ngIf="tableHeaders?.primaryText?.value == 'actions'" colspan="5">
              <div class="row">
                <div class="col dhl-hand-pointer-v2 dhl-action-styling-v2"
                  *ngFor="let action of rowActions | slice:0:3; trackBy: let i=index" [hidden]="action.hidden" [ngClass]="{'tool': action.toolTip,
                    'dhl-row-actions': true,
                    'dhl-view-v2': (action.name === 'edit' || action.name === 'draftView'),
                    'dhl-cancel-v2': (action.name === 'cancel' || action.name === 'decline'),
                    'dhl-upload-v2': (action.name === 'upload' || action.name === 'approve'),
                    'dhl-copy-v2': action.name === 'copy',
                    'dhl-download-v2': action.name === 'download',
                    'dhl-resend-v2': isResend(rowData,action),
                    'dhl-pod-download-v2': action.name === 'pod-download',
                    'dhl-release-v2': action.name === 'release',
                    'dhl-mark-vip-v2': isVip(rowData,action), 'dhl-unmark-vip-v2': isNotVip(rowData,action),
                    'dhl-default-escalation-v2': isNotEscalated(action,rowData),
                    'dhl-default-escalationNotesHistory-v2': isEscalationNotesHistory(action,rowData),
                    'dhl-default-holdDetails-v2': holdDetails(action,rowData),
                    'dhl-default-orderNotes-v2': isOrderNotes(action,rowData),
                    'dhl-filled-escalation-v2': isEscalated(action,rowData),
                    'disabled': (isCancelled(rowData.status, action) || isDisable(action,rowData) ||  accessActionsByStatus(action,rowData) || checkAccess(action))}"
                    (click)="!accessActionsByStatus(action,rowData) && handleRowActions($event, action, rowData[businessObjectIdType], rowData)">
                </div>
                <div class="col arrow-box" id="moreAction" *ngIf="rowActions.length > 2" (click)="isDisplayActions=!isDisplayActions"
                  [ngClass]="isDisplayActions ? 'dhl-btn-down-arrow' : 'dhl-btn-up-arrow'">
                </div>
            </div>
            </td>
          </tr>
          <div *ngIf="isDisplayActions" class="dhl-action-popup">
            <table class="dhl-action-table">
              <tr class="dhl-hand-pointer-v2" *ngFor="let action of rowActions;trackBy: let i = index" [hidden]="action.hidden">
                <td class="dhl-action-popup-v2" >
                  <span [hidden]="action.hidden" [ngClass]="{'tool':action.toolTip,
                    'dhl-row-actions': true,
                    'dhl-view-v2': (action.name === 'edit' || action.name === 'draftView'),
                    'dhl-cancel-v2': (action.name === 'cancel' || action.name === 'decline'),
                    'dhl-upload-v2': (action.name === 'upload' || action.name === 'approve'),
                    'dhl-copy-v2': action.name === 'copy',
                    'dhl-download-v2': action.name === 'download',
                    'dhl-resend-v2': isResend(rowData,action),
                    'dhl-mark-vip-v2': isVip(rowData,action),
                    'dhl-pod-download-v2': action.name === 'pod-download',
                    'dhl-release-v2': action.name === 'release',
                    'dhl-unmark-vip-v2': isNotVip(rowData,action),
                    'dhl-default-escalation-v2': isNotEscalated(action,rowData),
                    'dhl-default-escalationNotesHistory-v2': isEscalationNotesHistory(action,rowData),
                    'dhl-default-holdDetails-v2': holdDetails(action,rowData),
                    'dhl-default-orderNotes-v2': isOrderNotes(action,rowData),
                    'dhl-filled-escalation-v2': isEscalated(action,rowData),
                    'disabled': (isCancelled(rowData.status, action) || isDisable(action,rowData) || accessActionsByStatus(action,rowData) || checkAccess(action))
                    }" (click)="!accessActionsByStatus(action,rowData) && handleRowActions($event, action, rowData[businessObjectIdType], rowData)">
                  </span>
                </td>
                <td class="dhl-action-popup-v2">
                  <span class="dhl-actionpop-label" [ngClass]="{'disabled': (isCancelled(rowData.status, action) || isDisable(action,rowData) || accessActionsByStatus(action,rowData) || checkAccess(action))}" (click)="!accessActionsByStatus(action,rowData) && handleRowActions($event, action, rowData[businessObjectIdType], rowData)">{{action.toolTip | translate}}</span>
                </td>
              </tr>
            </table>
          </div>
        </table>
        </td>
      </tr>
    </tbody>

    <tfoot *ngIf="isLoading || showLoadMoreLabel">
      <tr>
        <td [attr.colspan]="tHeaders.length">
          <div [hidden]="!isLoading">
            <div class="spinner-load-more-aligment">
              <div class="custom-spinner progress-spinner-load-more" mode="determinate" value="100"></div>
            </div>
            </div>
          <div [hidden]="!showLoadMoreLabel" class="dhl-table-pagination-label cursor"  (click)="loadMore(tableconfig.rowActions, $event)">{{enum.Load_More_Button | translate}}</div>
        </td>
      </tr>
    </tfoot>
  </table>
  <div *ngIf="columnOrder" id="dhlPopupId" class="dhl-column-order-popup-v2" (click)="selectedDivId('dhlPopupId')" [ngClass]="{'small-device-popup': (isHandset$ | async)}">
    <div class="sidemenu-header">
      <span class="dhl-icon-column-order-cancel-v2" (click)="displayColumnOrder($event,'cancel')"></span>
    </div>
    <div class="spacingbetween">
      <span class="dhl-column-order-head-v2">{{enum.Column_Order_Header| translate}}</span>
      <span class="dhl-column-order-content-v2">{{enum.Column_Order_Content| translate}}</span>
    </div>
    <span class="dhl-column-reset-v2 left-spacing-manage-column">
      <button class="dhl-reset-button-v2" (click)="resetColumnOrder()">{{enum.Column_Order_ResetOrder | translate}}</button>
    </span>
    <div class="dhl-theaders-v2 left-spacing-manage-column">
      <ol cdkDropList class="dhl-ol-v2" (cdkDropListDropped)="drop($event)">
        <li class="dhl-headers-list-v2" *ngFor="let tableHeaders of columnOptions; trackBy: let i=index" cdkDrag
          [cdkDragDisabled]="!tableHeaders.draggable">
          <div class="dhl-drag-placeholder-v2" *cdkDragPlaceholder></div>
          <div class="dhl-rearrange-column-container-v2">
            <span class="dhl-column-order-font-v2">{{tableHeaders.title |translate}}</span>
            <img *ngIf="tableHeaders.draggable; else elseIcon"
              src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,420,24,24))"
              class="dhl-column-rearrange-icons-styling-v2">
            <ng-template #elseIcon>
              <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,450,24,24))"
                class="dhl-column-rearrange-icons-styling-v2">
            </ng-template>
            <div *cdkDragPreview class="dhl-headers-list-v2">
              <span class="dhl-column-order-font-bold-v2">{{tableHeaders.title |translate}}</span>
              <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,600,24,24))"
                class="dhl-column-rearrange-icons-styling-v2">
            </div>
          </div>
        </li>
      </ol>
      <span class="dhl-apply-v2">
        <button class="dhl-button-v2 buttons-primary" type="button"
          (click)="setcolumnOrderOptions('cancel')">{{enum.Column_Order_ApplyBtn | translate}}</button>
      </span>
    </div>
  </div>

  <div *ngIf="isDisplayStatus" [ngClass]="columnOptions[0].title === 'SELECT' ? 'dhl-status-typev2-v2' : 'dhl-status-type-v2'">
    <div class="arrow-left"></div>
    <ul class="dhl-status-type-font-v2">
      <div *ngIf="popupOptions.length >0">
        <span class="dhl-popup-head-v2" *ngIf="popmsgHead">{{popmsgHead}}</span>
        <li *ngFor="let pOptions of popupOptions;trackBy: index" class="popUp-status-li">
          <span class="dhl-ptype {{pOptions.className}}">{{pOptions.TypeText}} </span>
          <span *ngIf="pOptions" class="dhl-poption-v2">{{pOptions.status}}</span>
        </li>
      </div>
    <div *ngIf="!this.configData?.checkSubstatus">
      <li *ngFor="let pOptions of popupMarOptions;trackBy: index">
        <div>
          <span *ngIf="pOptions" class="dhl-type dhl-{{pOptions.toLowerCase().split(' ').join('')}}-status-v2"
             style="display:inline-block;     text-align: center;
             vertical-align: middle; height: 50px; background-size: 50px 50px; border-radius: 15%; background-repeat: no-repeat;"></span>

          <span *ngIf="pOptions" class="dhl-poption-v2">{{pOptions === 'MRN_NUMBER_RECEIVED_YES' ? 'MRN_ENTERED' : pOptions === 'MRN_NUMBER_RECEIVED_NO' ? 'MRN_NOT_ENTERED' : pOptions}}</span>
        </div>
      </li>
    </div>
    </ul>
  </div>
  <div *ngIf="isDisplayStatusM" class="dhl-mstatus-type-v2">
    <ul class="dhl-status-type-font-v2">
      <span class="dhl-popup-head-v2" *ngIf="popmsgHead">{{popmsgHead}}:</span>
      <li *ngFor="let pOptions of popupOptions;trackBy: index">
        <span>
          <span *ngIf="pOptions" class="dhl-ptype dhl-ptype-{{pOptions.charAt(0)}}-v2" width="10px">
            <span *ngIf="iconDetails['iconText'] && iconDetails['iconText'].includes(pOptions); else elseIcon">
              {{pOptions.substring(0,iconDetails['iconTextChars'])}}
            </span>
            <ng-template #elseIcon>
              {{pOptions.charAt(0)}}
            </ng-template>
          </span>
          <span *ngIf="pOptions" class="dhl-poption-v2">{{pOptions}}</span>
        </span>
      </li>
    <div *ngIf="!this.configData?.checkSubstatus">
      <li *ngFor="let pOptions of popupMarOptions;trackBy: index">
        <div>
          <span *ngIf="pOptions" class="dhl-type dhl-{{pOptions.toLowerCase().split(' ').join('')}}-status-v2"
             style="display:inline-block;     text-align: center;
             vertical-align: middle; height: 50px; background-size: 50px 50px; border-radius: 15%; background-repeat: no-repeat;"></span>

          <span *ngIf="pOptions" class="dhl-poption-v2">{{pOptions === 'MRN_NUMBER_RECEIVED_YES' ? 'MRN_ENTERED' : pOptions === 'MRN_NUMBER_RECEIVED_NO' ? 'MRN_NOT_ENTERED' : pOptions}}</span>
        </div>
      </li>
    </div>
    </ul>
  </div>
</div>
<div *ngIf="editField" class="dhl-form-self-service">
  <div class="sidemenu-header">
      <span class="dhl-icon-compoenent-cancel-v2" (click)="editFieldConfig('cancel','')"></span>
  </div>    
  <app-form-comp *ngIf="templateData" (formStatus)="getFormStatus($event)"   (form)="getForm($event)" [configData]=templateData [orderDetails]="tblHeaders"></app-form-comp>
  <app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
</div>
